var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPremiumPlan = function SvgPremiumPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#premium-plan_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.667c0 1.294-.667 6.039-.667 7.333",
    stroke: "url(#premium-plan_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.564 17.058c-3.237-3.063-3.237-12.633 0-15.696 3.655 3.063 3.463 12.633 0 15.696Z",
    fill: "url(#premium-plan_svg__c)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.193 17.25c-1.92-3.865 1.376-12.323 5.406-13.87 2.303 4.015-1.17 12.404-5.406 13.87Z",
    fill: "url(#premium-plan_svg__e)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.512 17.25c1.92-3.865-1.376-12.323-5.406-13.87-2.303 4.015 1.17 12.404 5.406 13.87Z",
    fill: "url(#premium-plan_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.385 17.24c-.123-4.454 6.644-11.222 11.1-11.099.417 4.75-6.486 11.382-11.1 11.1Z",
    fill: "url(#premium-plan_svg__i)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.32 17.24c.123-4.454-6.644-11.222-11.1-11.099-.417 4.75 6.486 11.382 11.1 11.1Z",
    fill: "url(#premium-plan_svg__k)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan_svg__b",
    x1: 11.667,
    y1: 16.667,
    x2: 11.667,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#267512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27940C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan_svg__c",
    x1: 11.685,
    y1: 1.362,
    x2: 11.685,
    y2: 17.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan_svg__e",
    x1: 17.71,
    y1: 3.423,
    x2: 12.304,
    y2: 17.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE3500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan_svg__g",
    x1: 5.995,
    y1: 3.423,
    x2: 11.401,
    y2: 17.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE3500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan_svg__i",
    x1: 22.57,
    y1: 6.227,
    x2: 11.47,
    y2: 17.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA88A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan_svg__k",
    x1: 1.135,
    y1: 6.227,
    x2: 12.235,
    y2: 17.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA88A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan_svg__d",
    x: 9.872,
    y: 2.06,
    width: 9.341,
    height: 16.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4404_7471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4404_7471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan_svg__f",
    x: 3.612,
    y: 2.06,
    width: 9.341,
    height: 16.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4404_7471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4404_7471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan_svg__h",
    x: 9.624,
    y: 4.82,
    width: 13.758,
    height: 13.748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4404_7471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4404_7471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan_svg__j",
    x: -0.556,
    y: 4.82,
    width: 13.758,
    height: 13.748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4404_7471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4404_7471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "premium-plan_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPremiumPlan;